/**
 * Kraken SDK bootstrap for material-dashboard (browser, Vue 2).
 *
 * - Builds a single KrakenSDK instance with the modules this app needs.
 * - Adds an axios request interceptor that injects the token currently stored
 *   in localStorage under "user.access_token" (matches src/services/auth-header.js).
 *
 * Usage from any component / store action:
 *   import { $k } from '@/lib/kraken'
 *   const orgs = await $k.manage.someEndpoint.get({ ... })
 *
 * To add another module (e.g. AuthSDK), import its class and add it to MODULES.
 */
import { KrakenSDK } from '@kraken/sdk'
import { ManageSDK } from '@kraken/manage'

const MODULES = [ManageSDK]

function getStoredToken () {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return null
    const user = JSON.parse(raw)
    return user && user.access_token ? user.access_token : null
  } catch (_) {
    return null
  }
}

export const $k = new KrakenSDK({
  axios: {
    config: {
      baseURL: process.env.VUE_APP_URL_API,
    },
    interceptors: {
      request: [
        (config) => {
          const token = getStoredToken()
          if (token) config.headers.Authorization = token
          return config
        },
        undefined,
      ],
    },
  },
}, MODULES).initialize()

export default $k
